module.exports = __webpack_public_path__ + "src/assets/img/cmd-clear-immo-gray.fae55aa2.svg";